import { type Attributes, type DisplayTokenAttribute, type TokenAttributes } from '@app/client';
interface UseTokenTraitsArgs {
    tokenAttributes?: TokenAttributes;
    collectionAttributes?: Attributes;
    totalTokens?: number;
}
export function useTokenTraits({ tokenAttributes, collectionAttributes, totalTokens = 1 }: UseTokenTraitsArgs) {
    if (tokenAttributes) {
        const tokenTraitKeys = Object.keys(tokenAttributes);
        const collectionAttributeKeys = collectionAttributes ? Object.keys(collectionAttributes) : undefined;
        const filteredKeys = collectionAttributeKeys
            ? collectionAttributeKeys.filter((key) => tokenTraitKeys.includes(key))
            : tokenTraitKeys;

        const matched =
            collectionAttributes &&
            filteredKeys?.map((key) => {
                const tokenAtt = tokenAttributes[key];
                const attr = collectionAttributes[key].find(({ value }) => tokenAtt?.values?.find((v) => v === value));
                return {
                    ...attr,
                    type: key,
                    name: attr?.value,
                    floorPriceEth: attr?.floor_eth,
                    traitCountPercentage: attr?.traitCount
                        ? Math.round((attr.traitCount / totalTokens) * 100)
                        : undefined,
                };
            });

        const unMatched = filteredKeys?.map((key) => {
            const tokenAtt = tokenAttributes[key];
            const attr = tokenAtt.values?.[0];
            return {
                type: key,
                name: attr,
            };
        });

        const items = matched || unMatched || [];
        return items.filter((t) => t !== undefined) as DisplayTokenAttribute[];
    } else {
        return [];
    }
}
